import { useState } from 'react';
import { FormModal } from './FormModal';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const platformTypes = [
  'Social Media',
  'Messaging Platform',
  'Gaming Platform',
  'Educational Technology',
  'Video/Streaming',
  'E-commerce',
  'Dating/Social',
  'Other'
];

const timelines = [
  'Immediate (0-3 months)',
  'Near-term (3-6 months)',
  'Medium-term (6-12 months)',
  'Long-term (12+ months)',
  'Exploratory'
];

export const CertificationInterestForm = ({ isOpen, onClose }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    organization: '',
    platform_type: '',
    current_safeguarding: '',
    timeline: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/forms/certification-interest`, formData);
      if (response.data.success) {
        toast.success('Certification Interest Registered', {
          description: response.data.message
        });
        onClose();
        setFormData({
          full_name: '',
          email: '',
          organization: '',
          platform_type: '',
          current_safeguarding: '',
          timeline: ''
        });
      }
    } catch (error) {
      toast.error('Submission Failed', {
        description: 'Please try again later.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FormModal isOpen={isOpen} onClose={onClose} title="Register Certification Interest">
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="certification-interest-form">
        <p className="text-sm text-slate-600 mb-6">
          Register your platform's interest in SAFE Labs certification. Our team will review your enquiry and respond within 5 business days.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Full Name *</label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              required
              className="input-institutional"
              data-testid="cert-input-name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="input-institutional"
              data-testid="cert-input-email"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Organization *</label>
            <input
              type="text"
              name="organization"
              value={formData.organization}
              onChange={handleChange}
              required
              className="input-institutional"
              data-testid="cert-input-org"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Platform Type *</label>
            <select
              name="platform_type"
              value={formData.platform_type}
              onChange={handleChange}
              required
              className="select-institutional"
              data-testid="cert-select-platform"
            >
              <option value="">Select type...</option>
              {platformTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Current Safeguarding Measures</label>
          <textarea
            name="current_safeguarding"
            value={formData.current_safeguarding}
            onChange={handleChange}
            placeholder="Describe your current child safety and safeguarding measures..."
            className="textarea-institutional"
            data-testid="cert-textarea-safeguarding"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Certification Timeline</label>
          <select
            name="timeline"
            value={formData.timeline}
            onChange={handleChange}
            className="select-institutional"
            data-testid="cert-select-timeline"
          >
            <option value="">Select timeline...</option>
            {timelines.map(timeline => (
              <option key={timeline} value={timeline}>{timeline}</option>
            ))}
          </select>
        </div>

        <div className="flex gap-4 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="btn-secondary flex-1"
            data-testid="cert-btn-cancel"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className="btn-primary flex-1 disabled:opacity-50"
            data-testid="cert-btn-submit"
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </form>
    </FormModal>
  );
};
